import { render, staticRenderFns } from "./poll.vue?vue&type=template&id=36e18dff&scoped=true"
import script from "./poll.vue?vue&type=script&lang=js"
export * from "./poll.vue?vue&type=script&lang=js"
import style0 from "./poll.styl?vue&type=style&index=0&id=36e18dff&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e18dff",
  null
  
)

export default component.exports